import { alipayCallNative } from '@hb/bridge-core';
import { INativeProxy, IAlipayMiniNative } from './lib/interface';

const NativeProxy: INativeProxy = {
  // 跳转链接
  goLinkUrl(url) {
    return alipayCallNative({
      classMap: 'Native',
      command: 'goLinkUrl',
      data: url,
    });
  },
  redirectTo(url) {
    return alipayCallNative({
      classMap: 'Native',
      command: 'goLinkUrl',
      dataArray: [url, true, true],
    });
  },
  goBack(delta) {
    return alipayCallNative({
      classMap: 'Native',
      command: 'navigateBack',
      data: delta,
    });
  },
  async getCityInfo(forceShowDialog) {
    const res = await alipayCallNative({
      classMap: 'Native',
      command: 'getMiniCityInfo',
      data: {
        forceShowDialog,
      },
    });
    return res.data || {};
  },
  async getTokenAndKey(needLogin) {
    const res = await alipayCallNative({
      classMap: 'Native',
      command: 'getTokenAndKey',
      data: {
        needLogin,
      },
    });
    return res.data || {};
  },
  /** @description 扫码 */
  async scanQRCode() {
    return await alipayCallNative({
      classMap: 'Native',
      command: 'scanCode',
    });
  },
  /** @description 选择图片 */
  async chooseImage(args?: any) {
    return await alipayCallNative({
      classMap: 'Native',
      command: 'chooseImage',
      data: {
        count: 1,
        sizeType: args?.sizeType,
        sourceType: args?.sourceType || ['camera'],
      },
    });
  },
  /**  @description 上传照片 */
  async uploadFile(url) {
    return alipayCallNative({
      command: 'uploadFile',
      classMap: 'Native',
      dataArray: [url, { image: 1, type: 4 }],
    });
  },
  /** @description 跳转页面（关闭当前页面） */
  async reLaunch(alipaySchema) {
    alipayCallNative({
      classMap: 'Native',
      command: 'reLaunch',
      data: alipaySchema,
    });
  },
};

const AlipayMiniNative = ({
  method,
  params,
  classMap = 'Native',
}: IAlipayMiniNative) => {
  if (NativeProxy[method]) {
    return NativeProxy[method](params);
  }
  return alipayCallNative({
    classMap,
    command: method,
    data: params,
  });
};
export default AlipayMiniNative;
